module.exports = __webpack_public_path__ + "static/media/answerChoose2.54994c30.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/answerChoose2.png
// module id = 1716
// module chunks = 0 1